const menuList = [
    {
        id: "2",
        icon: "el-icon-user-solid",
        name: "用户管理",
        url: "/userManage"
    },
    {
        id: "1",
        icon: "el-icon-document",
        name: "文案管理",
        url: "/wordsManage"
    },
    {
        id: "18",
        icon: "el-icon-microphone",
        name: "语音试听管理",
        url: "/voicePreviewManage"
    },
    {
        id: "16",
        icon: "el-icon-price-tag",
        name: "标签管理",
        url: "/memoryCircleTagManage"
    },
    {
        id: "17",
        icon: "el-icon-document-copy",
        name: "模板管理",
        url: "/memoryCircleTemplateManage"
    },
    // {
    //     id: "3",
    //     icon: "el-icon-cpu",
    //     name: "本地模型管理",
    //     url: "/localModelManage"
    // },
    {
        id: "4",
        icon: "el-icon-set-up",
        name: "线上模型管理",
        url: "/onlineModelManage"
    },
    // {
    //     id: "5",
    //     icon: "el-icon-bangzhu",
    //     name: "格式预设",
    //     url: "/presetsManage"
    // },
    {
        id: "6",
        icon: "el-icon-aim",
        name: "模式预设",
        url: "/modelPresetsManage"
    },
    // {
    //     id: "8",
    //     icon: "el-icon-odometer",
    //     name: "正则预设",
    //     url: "/expresPresetsManage"
    // },
    {
        id: "7",
        icon: "el-icon-stopwatch",
        name: "字典管理",
        url: "/dictionaryManage"
    },
    {
        id: "9",
        icon: "el-icon-data-line",
        name: "数据看板",
        url: "/dashboard"
    },
    // {
    //     id: "10",
    //     icon: "el-icon-picture",
    //     name: "微信卡片管理",
    //     url: "/wechatCardManage"
    // },
    {
        id: "11",
        icon: "el-icon-warning",
        name: "敏感词管理",
        url: "/sensitiveWordManage"
    },
    {
        id: "12",
        icon: "el-icon-document-checked",
        name: "日志诊断",
        url: "/diagnosticReports"
    },
    {
        id: "13",
        icon: "el-icon-mobile",
        name: "默认设备管理",
        url: "/wxMpDefaultDeviceManage"
    },
    {
        id: "14",
        icon: "el-icon-key",
        name: "邀请码管理",
        url: "/invitationDeviceManage"
    },
    {
        id: "15",
        icon: "el-icon-upload",
        name: "启动器更新",
        url: "/launcherUpdate"
    },
];

/*返回当前菜单列表*/
export function getMenuList() {
    return menuList;
}
